import {BuyBonusButtonView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonView';
import {BuyBonusButtonViewLandscape} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonViewLandscape';
import {BuyBonusButtonViewPortrait} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonViewPortrait';
import {isEnabledRubyCoins} from '@gongxigames/framework/slot/modules/buyBonus/isEnabledRubyCoins';
import {DefaultEventsMap, DeviceType, ModuleIsEnabledFilter} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {ScreenOrientedView} from '@gongxigames/framework/slot/fragments/module/view';

export class BuyBonusButtonViewMobile extends ScreenOrientedView<DefaultEventsMap, BuyBonusButtonView> {
    public static readonly NAME: symbol = Symbol('BuyBonusButtonViewMobile');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledRubyCoins;

    protected landscapeViewName: symbol = BuyBonusButtonViewLandscape.NAME;
    protected portraitViewName: symbol = BuyBonusButtonViewPortrait.NAME;

    public enableButton(): void {
        this._views.forEach((view: BuyBonusButtonView) => {
            view.enableButton();
        });
    }

    public disableButton(): void {
        this._views.forEach((view: BuyBonusButtonView) => {
            view.disableButton();
        });
    }

    public playAnimation(): void {
        this._views.forEach((view: BuyBonusButtonView) => {
            view.playAnimation();
        });
    }
}
